var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('v-card', {
    attrs: {
      "height": "100%",
      "width": "640px",
      "max-height": "125",
      "align": "center",
      "color": "grey lighten-4",
      "elevation": "0"
    }
  }, [_vm.item.file ? _c('v-img', {
    attrs: {
      "src": _vm.fileToUrl(_vm.item),
      "height": "100%",
      "max-height": "125",
      "contain": ""
    },
    on: {
      "click": _vm.openDialog
    }
  }) : _vm._e(), _vm.item.isLoading || _vm.item.isUploaded ? _c('v-btn', {
    staticClass: "topAdjusted overwriteDisbaled grey darken-4",
    attrs: {
      "loading": _vm.item.isLoading,
      "dark": "",
      "fab": "",
      "small": "",
      "absolute": "",
      "top": "",
      "right": "",
      "elevation": "0"
    },
    on: {
      "click": _vm.openDialog
    }
  }, [_vm.item.isUploaded ? _c('v-icon', [_vm._v(" mdi-check ")]) : _vm._e()], 1) : _vm._e()], 1), _c('v-dialog', {
    attrs: {
      "max-width": "600px"
    },
    model: {
      value: _vm.dialog,
      callback: function callback($$v) {
        _vm.dialog = $$v;
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_vm.item && _vm.item.file && _vm.item.file.name ? _c('v-card-title', [_vm._v(" " + _vm._s(_vm.item.file.name) + " ")]) : _vm._e(), _c('v-img', {
    staticClass: "align-end",
    attrs: {
      "contain": "",
      "src": _vm.dialogImage
    },
    on: {
      "click": function click($event) {
        _vm.dialog = false;
      }
    }
  }), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "red darken-1",
      "text": "",
      "data-test-delete-file": ""
    },
    on: {
      "click": _vm.deleteImage
    }
  }, [_vm._v(" Löschen ")]), _c('v-spacer'), _c('v-btn', {
    attrs: {
      "color": "green darken-1",
      "text": ""
    },
    on: {
      "click": function click($event) {
        _vm.dialog = false;
      }
    }
  }, [_vm._v(" Ok ")])], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }